import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UserDataModel } from 'src/app/store/user-data.model';
import { SetUserDataAction } from 'src/app/store/user-data.actions';
import { appConfig } from 'src/app/config/config';
import { filter } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UserDataService {

    // @ts-ignore
    public userDataObject: UserDataModel;
    private readonly nameSess: string;
    private user_data: UserDataModel = new UserDataModel({
        name: '',
        lastname1: '',
        lastname2: '',
        email: '',
        phone1: '',
        phone2: '',
        currentCompany: '',
        coverage: '',
        specSheet: '',
        driverIdentification: '',
        license: '',
        checkPrivacy: false,
        checkCalling: false
    });

    constructor(private store: Store<AppState>) {
        this.nameSess = appConfig.data_session;
        this.loadData();
    }

    loadData(): UserDataModel {
        if (localStorage.getItem(this.nameSess)) {
            // @ts-ignore
            this.user_data = JSON.parse(atob(localStorage.getItem(this.nameSess)));
        }
        this.store.dispatch(new SetUserDataAction(this.user_data));
        this.persistData(this.user_data);
        this.store.select('user_data_state')
            .pipe(filter(state => state.userData != null))
            .subscribe(user_data_state => {
                this.userDataObject =  new UserDataModel({
                        name: user_data_state.userData.name,
                        lastname1: user_data_state.userData.lastname1,
                        lastname2: user_data_state.userData.lastname2,
                        email: user_data_state.userData.email,
                        phone1: user_data_state.userData.phone1,
                        phone2: user_data_state.userData.phone2,
                        currentCompany: user_data_state.userData.currentCompany,
                        coverage: user_data_state.userData.coverage,
                        specSheet: user_data_state.userData.specSheet,
                        driverIdentification: user_data_state.userData.driverIdentification,
                        license: user_data_state.userData.license,
                        checkPrivacy: user_data_state.userData.checkPrivacy,
                        checkCalling: user_data_state.userData.checkCalling
                    }
                );
            });
        return this.userDataObject;
    }

    persistData(user_data: UserDataModel) {
        this.user_data = user_data;
        let data_sess = btoa(JSON.stringify(this.user_data));
        localStorage.setItem(this.nameSess, data_sess);
    }

}
